module.exports = __webpack_public_path__ + "static/media/20201114_155358_418_IMG_9996.eccd7993.jpg";